import { Page } from "@boundary/layouts/pageLayout";
import { Button } from "@boundary/components/button";
import { PrefetchLink } from "@boundary/components/prefetchLink";
import styles from "./about.module.scss";

export function AboutPage() {
  return (
    <Page className={styles.page} screenBackground="sub" withFog>
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Body className={styles.body}>
          <div className={styles.textBlock}>
            <h1 className={styles.title}>О нас</h1>
            <p className={styles.description}>
              PhoDo — это{"\n"}
              умная станция печати с ячейками хранения и выдачи заказов,{"\n"}
              которая избавляет от очередей и позволяет печатать в любое время!
            </p>
          </div>
          <img
            src="/assets/postomat.webp"
            className={styles.image}
            alt="PhoDo постамат"
          />
        </Page.DisplayZone.Body>
        <Page.DisplayZone.Sticky className={styles.buttonPad}>
          <Button asChild>
            <PrefetchLink to="/login">
              Далее
            </PrefetchLink>
          </Button>
        </Page.DisplayZone.Sticky>
      </Page.DisplayZone>
    </Page>
  );
}
